import { ds } from "js/core/models/dataService";
import { $ } from "js/vendor";
import { app } from "js/namespaces.js";
import { controls } from "js/editor/ui";

import { CollectionElementSelection, CollectionItemElementSelection } from "../CollectionElementEditor";

const BubbleTimelineSelection = CollectionElementSelection.extend({
    renderControls: function() {
        this.createAddItemButton();

        this.addControl({
            type: controls.CHECKBOX,
            label: "AutoFit",
            property: "autoFit"
        });

        this.addControl({
            type: controls.SLIDER,
            label: "Distance",
            min: 1,
            max: 300,
            property: "bubbleDistance"
        });

        this.addControl({
            type: controls.POPUP_BUTTON,
            label: "Layout",
            items: [{ value: "straight", label: "Straight" }, { value: "zigzag", label: "Zig Zag" }, { value: "ascending", label: "Ascending" }, { value: "descending", label: "Descending" }, { value: "random", label: "Random" }],
            callback: value => this.setLayout(value)
        });

        this.addControl({
            type: controls.POPUP_BUTTON,
            label: "Size",
            items: [{ value: "small", label: "Small" }, { value: "medium", label: "Medium" }, { value: "large", label: "Large" }, { value: "random", label: "Random" }, { value: "grow", label: "Grow" }, { value: "shrink", label: "Shrink" }],
            callback: value => this.setSize(value)
        });

        this.renderScrollBar();
    },

    renderScrollBar: function() {
        if (this.element.calculatedLayout.totalBounds.width > this.element.innerBounds.width) {
            this.$scrollTrack = this.$el.addEl($.div("scroll_track"));
            let $scrollThumb = this.$scrollTrack.addEl($.div("scroll_thumb"));

            $scrollThumb.draggable({
                axis: "x",
                containment: "parent",
                start: () => {
                    app.isDraggingItem = true;
                },
                drag: (event, ui) => {
                    let percent = ui.position.left / (this.$scrollTrack.width() - $scrollThumb.width());
                    this.element.setScroll(this.element.getMaxScroll() * percent);
                },
                stop: () => {
                    app.isDraggingItem = false;
                }
            });
        }
    },

    _layout: function(bounds) {
        if (this.$scrollTrack) {
            let scrollThumbWidth = this.elementBounds.width / (this.elementBounds.width + this.element.getMaxScroll()) * this.$scrollTrack.width();
            // let scrollThumbWidth = this.elementBounds.width / this.canvasToSelectionCoordinates(this.element.calculatedLayout.totalBounds.width + this.element.styles.marginLeft + this.element.styles.marginRight) * this.$scrollTrack.width();
            let scrollPercent = (this.element.scroll || 0) / this.element.getMaxScroll();
            let scrollX = (this.$scrollTrack.width() - scrollThumbWidth) * scrollPercent;
            this.$scrollTrack.find(".scroll_thumb").width(scrollThumbWidth).left(scrollX);
        }
    },

    setLayout: function(type) {
        switch (type) {
            case "straight":
                for (let item of this.element.itemViews) {
                    item.model.set("y", 0, { silent: true });
                }
                break;
            case "zigzag":
                var y = 100;
                for (let item of this.element.itemViews) {
                    item.model.set("y", y, { silent: true });
                    y *= -1;
                }
                break;
            case "random":
                for (let item of this.element.itemViews) {
                    item.model.set("y", Math.round(Math.random() * 300 - 150), { silent: true });
                }
                break;
            case "ascending":
                for (let i = 0; i < this.element.itemViews.length; i++) {
                    this.element.itemViews[i].model.set("y", -100 + i / this.element.itemViews.length * 200, { silent: true });
                }
                break;
            case "descending":
                for (let i = 0; i < this.element.itemViews.length; i++) {
                    this.element.itemViews[i].model.set("y", 100 - i / this.element.itemViews.length * 200, { silent: true });
                }
                break;
        }
        this.element.refreshLayout(true);
        ds.selection.slide.commit();
    },

    setSize: function(type) {
        switch (type) {
            case "small":
                for (let item of this.element.itemViews) {
                    item.model.set("size", 100, { silent: true });
                }
                break;
            case "medium":
                for (let item of this.element.itemViews) {
                    item.model.set("size", 200, { silent: true });
                }
                break;
            case "large":
                for (let item of this.element.itemViews) {
                    item.model.set("size", 300, { silent: true });
                }
                break;
            case "random":
                for (let item of this.element.itemViews) {
                    item.model.set("size", Math.random() * 200 + 100, { silent: true });
                }
                break;
            case "grow":
                for (let i = 0; i < this.element.itemViews.length; i++) {
                    this.element.itemViews[i].model.set("size", 100 + i / this.element.itemViews.length * 300, { silent: true });
                }
                break;
            case "shrink":
                for (let i = 0; i < this.element.itemViews.length; i++) {
                    this.element.itemViews[i].model.set("size", 300 - i / this.element.itemViews.length * 300, { silent: true });
                }
                break;
        }
        this.element.refreshLayout(true);
        ds.selection.slide.commit();
    }
});

const BubbleTimelineItemSelection = CollectionItemElementSelection.extend({
    canDrag: function() {
        return false;
    },

    renderControls: function() {
        // make the rollover draggable and connect it to the layout engine
        this.$el.draggable({
            axis: "y",
            distance: 5,
            containment: this.canvasToScreenCoordinates(this.element.getRootElement()).deflate({ bottom: this.elementBounds.height }).toArray(),
            start: (event, ui) => {
                app.isDraggingItem = true; // i guess this is a bit ugly but we need a quick way for canvas and baseelement to know if we are dragging and prevent us from losing rollover focus if the mouse moves too fast
                this.$el.opacity(0);
                this.$el.find(".ui_widget").opacity(0);
            },
            drag: (event, ui) => {
                let dragY = this.selectionToCanvasCoordinates(ui.position.top);
                let y = dragY - this.element.parentElement.canvasBounds.centerV + this.element.calculatedLayout.contentBounds.height / 2;
                this.model.set("y", -y);
            },
            stop: (event, ui) => {
                ds.selection.slide.commit();
                app.isDraggingItem = false;
                this.$el.find(".ui_widget").velocity("transition.fadeIn");
            }
        });

        this.addControl({
            type: controls.POPUP_BUTTON,
            label: "Style",
            items: [{ value: "image", label: "Image" }, { value: "text", label: "Text" }, { value: "icon", label: "Icon" }, { type: "divider" }, {
                type: "control",
                view: () => controls.createToggle(this, {
                    label: "Show Caption",
                    property: "showCaption",
                    model: this.element.model
                })
            }],
            callback: value => {
                this.element.model.set("contentStyle", value);
                ds.selection.slide.commit();
            }
        });

        // this.addControl({
        //     type: controls.CHECKBOX,
        //     label: "Show Caption",
        //     property: "showCaption"
        // });

        this.addControl({
            type: controls.SLIDER,
            label: "Size",
            min: 25,
            max: 475,
            property: "size",
            onStart: () => {
                this.hideRolloverSelection();
            },
            onEnd: () => {
                this.showRolloverSelection();
                ds.selection.rolloverElement = this.element.parentElement;
            }
        });
    }

});

export const editors = {
    BubbleTimelineSelection,
    BubbleTimelineItemSelection,
};
